import { Box, Typography } from "@mui/material";

interface IDeleteConfirmationContent {
  title: string;
  value?: string;
  afterValue?: string;
  hasQuestionMark?: boolean;
}

export const ConfirmationContent = (props: IDeleteConfirmationContent) => {
  const { title, value, afterValue, hasQuestionMark = true } = props;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowX: "hidden",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
        }}
      >
        {title}
        {value && (
          <Typography
            component={"span"}
            sx={{ wordBreak: "break-word", width: "100%", display: "inline", fontWeight: "fontWeightSemiBold" }}
          >
            {` ${value}`}
          </Typography>
        )}

        {afterValue && (
          <Typography component={"span"} sx={{ wordBreak: "break-word", width: "100%", display: "inline" }}>
            {` ${afterValue}`}
          </Typography>
        )}

        {hasQuestionMark && " ?"}
      </Typography>
    </Box>
  );
};
